const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneralCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon ",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 33",
    width: 39,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ChatBubblesWithQuestionMark--a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 19.24a12.73 12.73 0 1 1 4.43 4.42l-5.9 1.97c-.4.13-.63-.09-.5-.5l1.98-5.9z",
    className: "Icon__blendBackground",
    style: {
      fill: "#80e9ff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2 19.24a12.73 12.73 0 1 1 4.43 4.42l-5.9 1.97c-.4.13-.63-.09-.5-.5l1.98-5.9z",
    className: "Icon__blendBackground",
    style: {
      fill: "#80e9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.73 10.73a12.73 12.73 0 0 1 19.93 15.5l1.97 5.9c.13.41-.09.63-.5.5l-5.9-1.97a12.73 12.73 0 0 1-15.5-19.93zM25.5 23.4c-.93 0-1.68.8-1.68 1.8s.75 1.8 1.68 1.8c.93 0 1.69-.8 1.69-1.8s-.76-1.8-1.69-1.8zm-3.2-10.1A4.73 4.73 0 0 0 21 16.8h2.66c0-1.74.92-2.47 1.88-2.47.4-.07.83.06 1.13.37.3.3.45.75.4 1.19 0 1.15-.16 1.37-1.15 2.18a4.11 4.11 0 0 0-1.77 3.53h2.48c.14-.9.65-1.67 1.38-2.11A4 4 0 0 0 30 16.04c0-1.39-.96-4.03-4.38-4.03a4.13 4.13 0 0 0-3.33 1.29z",
    className: "Icon__blendForeground",
    style: {
      fill: "#7a73ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ChatBubblesWithQuestionMark--a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.73 10.73a12.73 12.73 0 0 1 19.93 15.5l1.97 5.9c.13.41-.09.63-.5.5l-5.9-1.97a12.73 12.73 0 0 1-15.5-19.93zM25.5 23.4c-.93 0-1.68.8-1.68 1.8s.75 1.8 1.68 1.8c.93 0 1.69-.8 1.69-1.8s-.76-1.8-1.69-1.8zm-3.2-10.1A4.73 4.73 0 0 0 21 16.8h2.66c0-1.74.92-2.47 1.88-2.47.4-.07.83.06 1.13.37.3.3.45.75.4 1.19 0 1.15-.16 1.37-1.15 2.18a4.11 4.11 0 0 0-1.77 3.53h2.48c.14-.9.65-1.67 1.38-2.11A4 4 0 0 0 30 16.04c0-1.39-.96-4.03-4.38-4.03a4.13 4.13 0 0 0-3.33 1.29z",
    className: "Icon__blendForeground",
    style: {
      fill: "#0048e5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralCommunication);
export default __webpack_public_path__ + "static/media/general_communication.2ce4824eb1d528b35dc7e6f65cf15dc0.svg";
export { ForwardRef as ReactComponent };